import { render, staticRenderFns } from "./PostActions.vue?vue&type=template&id=73827cd4&scoped=true&"
import script from "./PostActions.vue?vue&type=script&lang=js&"
export * from "./PostActions.vue?vue&type=script&lang=js&"
import style0 from "./PostActions.vue?vue&type=style&index=0&id=73827cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73827cd4",
  null
  
)

export default component.exports